module.exports = __webpack_public_path__ + "img/triangle-top.e16926f2.svg";